<template>
   <div class="hovered-btn dots-icon">
			<svg class="default" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M11.5 23C12.8807 23 14 21.8807 14 20.5C14 19.1193 12.8807 18 11.5 18C10.1193 18 9 19.1193 9 20.5C9 21.8807 10.1193 23 11.5 23Z" stroke="#7B8794" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M11.5 14.5C12.8807 14.5 14 13.3807 14 12C14 10.6193 12.8807 9.5 11.5 9.5C10.1193 9.5 9 10.6193 9 12C9 13.3807 10.1193 14.5 11.5 14.5Z" stroke="#7B8794" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M11.5 6C12.8807 6 14 4.88071 14 3.5C14 2.11929 12.8807 1 11.5 1C10.1193 1 9 2.11929 9 3.5C9 4.88071 10.1193 6 11.5 6Z" stroke="#7B8794" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
			<svg class="hovered" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M11.5 23C12.8807 23 14 21.8807 14 20.5C14 19.1193 12.8807 18 11.5 18C10.1193 18 9 19.1193 9 20.5C9 21.8807 10.1193 23 11.5 23Z" stroke="#7B8794" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M11.5 14.5C12.8807 14.5 14 13.3807 14 12C14 10.6193 12.8807 9.5 11.5 9.5C10.1193 9.5 9 10.6193 9 12C9 13.3807 10.1193 14.5 11.5 14.5Z" stroke="#7B8794" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M11.5 6C12.8807 6 14 4.88071 14 3.5C14 2.11929 12.8807 1 11.5 1C10.1193 1 9 2.11929 9 3.5C9 4.88071 10.1193 6 11.5 6Z" stroke="#7B8794" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
	</div>
</template>

<style scoped>
.dots-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding-top: 3px;
  position: relative;
  z-index: 0;
}
.dots-icon::before {
  content: '';
  position: absolute;
  top: 3px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 12px;
  border-radius: 4px;
  background-color: transparent;
  transition: background-color 0.15s ease;
  z-index: -1;
}
.dots-icon:hover::before {
  background-color: #ffffff;
}
</style>